<template>
    <div class="sidebar col-4" v-if="user!=null" v-loading="loading">
        <div class="profile-picture">
            <div class="overlay"></div>
            <el-upload
                class="avatar-uploader"
                :action="routes.profile_upload_image"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="user.profile_image_url" :src="imgPath" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!--<img class="img-fluid" src="images/profile-pic.png">-->
        </div>
        <div class="profile-info" v-if="!editMode">
            <p class="text-right"><i class="fas fa-edit cursor-pointer btn-edit" @click="editMode=true"></i></p>

            <h4>{{user.name +' '+ user.last_name}}</h4>
            <p class="city"><i class="icon-location-pin"></i> {{user.city? user.city : 'no city yet'}},
                {{user.state!==null && user.state!==undefined? user.state.slug: 'N/A'}} {{user.zip? user.zip : 'N/A'}}
            </p>
            <p class="profession"><strong>Profession:</strong><br>
                {{user.profession? user.profession : "No profession yet" }}</p>
            <p class="interests"><strong>Interests:</strong><br>
                {{user.interests ? user.interests : "No interests yet" }}</p>

            <p class="email">{{user.email}}</p>
            <el-tooltip :disabled="profile.assessments_completed_at!==null"
                        placement="top"
                        content="First finish all assessments"
                        effect="light">
                <p class="mb-1">

                    <button class="btn btn-success btn-profile-side"
                            @click="sendPdf">
                        Email Results
                        <i class="icon-envelope"></i>
                    </button>

                </p>
            </el-tooltip>
            <p class="mt-1">
                <button class="btn btn-success
                        btn-profile-side"
                        :disabled="screenshot"
                        @click="getPdf">
                    {{printPageLabel}}
                    <i class="icon-printer"></i>
                </button>
            </p>

        </div>

        <div class="profile-info" v-if="editMode">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="name" :class="requiredLabelClass.name">Name:*</label>
                        <input type="text" id="name" :class="requiredInputClass.name" v-model="user.name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="last_name" :class="requiredLabelClass.last_name">Last Name:*</label>
                        <input type="text" id="last_name" :class="requiredInputClass.last_name"
                               v-model="user.last_name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="city">City:</label>
                        <input type="text" id="city" class="form-control" v-model="user.city">
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label for="zip" :class="requiredLabelClass.zip">ZIP Code:*</label>
                        <input type="number" id="zip" :class="requiredInputClass.zip  " v-model="user.zip">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group" v-if="$root.$refs.prolit.appData.app != undefined">
                        <label for="state">State</label>
                        <select id="state" v-model="user.state_id" class="form-control">
                            <option v-for="state in states" :value="state.id">{{state.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="professions">Professions:</label>
                        <input type="text" id="professions" class="form-control" v-model="user.profession">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="Interests">Interests:</label>
                        <input type="text" id="Interests" class="form-control" v-model="user.interests">
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col text-center buttons-container">
                    <button class="btn btn-outline-default btn-outline-light mr-3" @click="cancel">Cancel<i
                        class="ml-2 fas fa-close"></i></button>
                    <button class="btn btn-default btn-success" @click="update()">Save<i class="ml-2 fas fa-save"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.user = this.profile;
        },
        props: {
            profile: {
                required: true,
            },

        },
        data() {
            return {
                user: {
                    name: '',
                    last_name: '',
                    zip: ''
                },
                editMode: false,
                validating: false,
                loading: false,
                imageUrl: '',
                screenshot: false,
                globalLoading: null,

            }
        },
        computed: {
            printPageLabel() {
                return this.screenshot ? 'Processing...' : "Print Page"
            },
            states() {
                return this.$root.$refs.prolit.appData.app.states;
            },
            routes() {
                return window.App.routes.api;
            },
            payloadErrors() {
                return {
                    name: this.validating && (this.user.name === null || this.user.name.trim() === ""),
                    last_name: this.validating && (this.user.last_name === null || this.user.last_name.trim() === ""),
                    zip: this.validating && (this.user.zip === null || this.user.zip.trim() === ""),
                }
            },
            imgPath() {
                let imageURL = this.user.profile_image_url !== null
                    ? this.user.profile_image_url[0] === '/'
                        ? window.location.protocol + '//' + window.location.hostname + this.user.profile_image_url
                        : this.user.profile_image_url
                    : null;
                console.log(imageURL)
                return imageURL ? new URL(imageURL).pathname : null;
            },
            payload() {
                return {
                    "name": this.user.name,
                    "last_name": this.user.last_name,
                    "zip": this.user.zip,
                    "city": this.user.city,
                    "state_id": this.user.state_id,
                    "profession": this.user.profession,
                    "interests": this.user.interests,
                };
            },
            requiredInputClass() {
                return {
                    name: this.payloadErrors.name ? 'form-control is-invalid' : "form-control",
                    last_name: this.payloadErrors.last_name ? 'form-control is-invalid' : "form-control",
                    zip: this.payloadErrors.zip ? 'form-control is-invalid' : "form-control",

                }
            },
            requiredLabelClass() {
                return {
                    name: this.payloadErrors.name ? 'text-danger' : "",
                    last_name: this.payloadErrors.last_name ? 'text-danger' : "",
                    zip: this.payloadErrors.zip ? 'text-danger' : "",

                }
            }
        },
        methods: {
            update() {
                if (this.validate()) {
                    this.loading = true
                    axios.put(this.routes.profile_edit, this.payload).then(response => {
                        this.loading = false;
                        this.editMode = false;
                        this.refreshProfileData();
                        this.$notify({
                            title: 'Success',
                            message: response.data.response.message,
                            type: 'success'
                        });
                    }).catch(e => {
                        console.log(e);
                        this.loading = false;
                        this.refreshProfileData();
                        this.$notify({
                            title: 'Warning',
                            message: "something wrong please refresh and try again",
                            type: 'warning'
                        });
                    });
                }
            },
            validate() {
                let hasError = false;
                this.validating = true;
                for (let error in this.payloadErrors) {
                    if (this.payloadErrors[error]) {
                        hasError = true;
                    }
                }
                return !hasError;

            },
            refreshProfileData() {
                axios.get(this.routes.profile_show).then(response => {
                    this.user = response.data.data;
                }).catch(e => console.log(e));
            },
            cancel() {
                this.editMode = false;
                this.$notify({
                    title: 'Info',
                    message: 'Update Canceled',
                    type: 'info'
                });
                this.refreshProfileData();
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
                this.refreshProfileData();
            },
            beforeAvatarUpload(file) {
                // const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                // if (!isJPG) {
                //     this.$message.error('La imagen debe estar en formato JPG!');
                // }
                if (!isLt2M) {
                    this.$message.error('image excess 2MB!');
                }
                // return isJPG && isLt2M;
                return isLt2M;
            },
            getPdf() {
                window.print();
                //here code for hide buttons
                // this.getProfileImage('pdf') //this return true on success image capture, to show the buttons again
            },
            sendPdf() {
                //here code for hide button
                this.getProfileImage('email') //this return true on success image capture, to show the buttons again
            },
            getProfileImage(purpose) {
                this.globalLoading = this.$loading();
                let vm = this;
                let node = window.document.getElementById('domtoimage')
                window.domtoimage.toJpeg(node, {filter: vm.captureFilter})
                    .then(function (dataUrl) {
                        vm.screenshot = false;
                        let image = new Image();
                        image.onload = function () {
                            var height = image.height;
                            var width = image.width;
                            console.log('The image size is ' + width + '*' + height);
                            vm.downloadPdf(dataUrl, width, height, purpose);
                            return true;
                        }


                        image.src = dataUrl;
                    })
                    .catch(function (error) {
                        console.error('oops, something went wrong!', error);
                        return false;
                    });
            },
            downloadPdf(dataUrl, width, height, purpose) {
                let vm = this;
                let url = purpose === 'pdf' ? window.App.routes.api.profile_pdf : window.App.routes.api.profile_email;

                axios({
                    method: 'post',
                    url,
                    responseType: 'blob',
                    data: {
                        dataImage: dataUrl,
                        width,
                        height
                    }
                }).then(response => {
                    if (purpose === 'pdf') {
                        vm.globalLoading.close();
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.pdf');
                        document.body.appendChild(link);
                        link.click();
                        return;
                    }
                    vm.globalLoading.close();
                    this.$notify({
                        title: 'Email Sent',
                        message: 'Check your email inbox',
                        type: 'success'
                    });
                    // swal("Email Sent!", "Check your email inbox!", "success");


                }).catch(e => {
                    vm.globalLoading.close();
                    console.log(e)
                });
            },
            captureFilter(node) {
                return (node.tagName !== 'button');
            }

        }
    }
</script>

<style scoped>
    .overlay {
        background-color: #006595;
        opacity: 0.5;
        /*position: absolute;*/
        /*left: 0;*/
        /*top: 0;*/
        /*width: 100%;*/
        /*height: 100%;*/
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .profile-picture {
        text-align: center !important;
        position: relative;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: white;
        width: 100%;
        height: 300px;
        line-height: 300px;
        text-align: center;
        transition: background-color;
        transition-duration: 200ms;
        transition-timing-function: ease-in-out;
    }

    .avatar-uploader-icon:hover {
        background: rgba(255, 255, 255, .5);
    }

    div.el-upload.el-upload--text {
        width: 100% !important;
    }

    .avatar {
        width: 100%;
        /*height: 178px;*/
        display: block;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/my_profile/Profile.vue